<template>
    <v-container>
        <h2 class="my-text-black" style="text-align: center;">Nueva solicitud de reintegro</h2>

        <v-divider id="divider" class="mb-4"></v-divider>
        <v-alert
            text="Factura original (tipo B ó C) y/o recibo de pago debidamente conformados (que cumplan con los recaudos fiscales vigentes): con el detalle de lo realizado en la descripción de la factura."                                        
            title="Aviso"
            type="info"
            variant="outlined"
            color="#3c3c3b"
        ></v-alert>
        <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
            <v-label class="my-text-black mt-4">Comprobante de CBU</v-label>
            <ImageInput
                v-model:imagenes="comprobante"
                :maxImages="1"
                :obligatorio="true"
                :nombreImagen="CBU_"
            ></ImageInput>
            <div class="d-flex align-center flex-column">
                <h3 class="my-text-black mt-4 mb-4">Indique a qué pertenece el reintegro</h3>
                <v-btn-toggle
                    v-model="reintegro.opcionElegida"
                    variant="flat"
                    divided
                    color="#254126"
                    >
                    <v-btn value="Cirugía/internación">Cirugía/internación</v-btn>
                    <v-btn value="Práctica">Práctica</v-btn>
                    <v-btn value="Urgencia">Urgencia</v-btn>
                </v-btn-toggle>
            </div>
            <div v-if="reintegro.opcionElegida">
                <v-label class="my-text-black mt-4">Archivos requeridos: </v-label>
                <div v-for="(elem, i) in nombresArchivos" :key="i">
                    <v-label class="my-text-black mt-4">{{elem.nombre}}</v-label>
                    <ImageInput
                        v-model:imagenes="reintegro.documentacion"
                        :maxImages="10"
                        :obligatorio="true"
                        :nombreImagen="elem.nomBack+'_'"
                        :pisable="false"
                    ></ImageInput>
                </div>
            </div>
            <v-label class="my-text-black mt-4">Archivos opcionales: </v-label>
            <ImageInput
                v-model:imagenes="reintegro.documentacion"
                :nombreImagen="OP_"
                :maxImages="20"
                :pisable="false"
            ></ImageInput>
            <v-label class="my-text-black mt-4">Razones por las cuales requiere el reintegro</v-label>
            <v-textarea
                v-model="reintegro.observaciones"
                label="Observaciones"
                rows="3"
                class="mt-4"
                variant="solo"
            ></v-textarea>
            <v-label class="my-text-black mt-4">Monto gastado estimado</v-label>
            <v-text-field
                :rules="reglaOpNum"
                v-model="reintegro.montoDeclarado"
                label="Gasto estimado"
                class="mt-4"
                variant="solo"
                prepend-inner-icon="mdi mdi-currency-usd"
            ></v-text-field>
            <v-container class="d-flex justify-center align-center">
                <Loader v-if="cargando"></Loader>
            </v-container>
            <v-btn
                type="submit"
                id="boton-verde"
                block
                :disabled="!valid || !reintegro.opcionElegida || cargando"
                :loading="cargando"
                class="mt-4"
            >Enviar solicitud</v-btn>
        </v-form>
    </v-container>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="cerrarModal"
    />
</template>

<style src="../assets/general.css"></style>

<script>
/* eslint-disable */
    import ImageInput from "@/components/ImageInput.vue";
    import { obligatorio, opcionalNumerico } from "@/_helpers/rules";
    import AlertComponent from "./AlertComponent.vue";
    import Loader from "./Loader.vue";
    import Reintegro from "@/interfaces/reintegroInterfaces"
    import ReintegroService from "@/api/ReintegroService";
import { load } from "webfontloader";

    const reintegroService = new ReintegroService();

    export default {
        components:{
            ImageInput,
            AlertComponent,
            Loader
        },
        data(){
            return{
                valid: false,
                cargando: false,
                comprobante:[],
                reintegro: Reintegro = {
                    pacienteId: null,
                    nroTransaccion: null,
                    comprobanteCBU: {},
                    documentacion: [],
                    montoDeclarado: "",
                    observaciones: "",
                    opcionElegida: null
                },
                reglaOpNum : opcionalNumerico,
                reglaObligatorio : obligatorio,
                opcionesFiles: [
                    {
                        opcion: "Cirugía/internación",
                        nombresFiles: [{nombre:"Orden Médica",nomBack:"OM"}, {nombre:"Resumen de Historia Clínica/Epicrisis", nomBack:"HC-E"},{nombre:"Estudios médicos que avalen la necesidad de la prestación", nomBack:"NP"}]
                    },
                    {
                        opcion: "Práctica",
                        nombresFiles: [{nombre:"Orden Médica", nomBack:"OM"}, {nombre:"Resumen de Historia Clínica", nomBack:"HC"},{nombre:"Resultado", nomBack:"R"}]
                    },
                    {
                        opcion: "Urgencia",
                        nombresFiles: [{nombre:"Nota motivo de urgencia", nomBack:"MU"},{nombre: "Epicrisis", nomBack: "E"}]
                    }
                ],
                //datos para mostrar errores
                showAlert:false,
                alertTitle: 'Error',
                alertText: 'Credenciales inválidas.',
                alertType: 'error',
            }
        },
        computed:{
            nombresArchivos(){
                return this.opcionesFiles.find(opcion => opcion.opcion === this.reintegro.opcionElegida).nombresFiles;
            }
        },
        methods:{
            async handleSubmit(){
                this.cargando = true;
                this.armarReintegro();
                const response = await reintegroService.postReintegro(this.reintegro);
                if(response){
                    this.manejarRespuesta(response);
                }
                this.cargando = false;
            },
            armarReintegro(){
                this.reintegro.pacienteId = this.$store.getters.getPaciente.id;
                this.reintegro.numeroDeReintegro = this.$store.getters.getPaciente.nroTransaccion;
                this.reintegro.comprobanteCBU = this.parsearArchivos(this.comprobante);
                this.reintegro.comprobanteCBU = this.reintegro.comprobanteCBU[0];
                this.reintegro.documentacion = this.parsearArchivos(this.reintegro.documentacion);
            },
            manejarRespuesta(response){
                if(response.status === 200){
                    this.alertTitle= "Reintegro creado";
                    this.alertText= "Podrá visualizarlo junto con su estado en el listado de reintegros.";
                    this.alertType="success";
                    this.showAlert= true;
                }
                else{
                    this.alertTitle= "Error";
                    this.alertText= response.data;
                    this.alertType="error";
                    this.showAlert= true;
                }
            },
            parsearArchivos(files){
                let filesSinId = [];
                files.forEach(file => {
                    filesSinId.push({
                        nombre: file.nombre,
                        tipoMime: file.tipoMime,
                        contenidoBase64: file.contenidoBase64
                    });
                });
                return filesSinId;
            },
            cerrarModal(){
                this.showAlert = false;
                if(this.alertType === 'success'){
                    this.$emit('reiniciarValidacion');
                    this.$router.push('/reintegros/home');
                }
            },
        }
    }
</script>